var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("jkfkkfk")]),_c('stripe-element-payment',{ref:"paymentRef",attrs:{"pk":_vm.pk,"elements-options":_vm.elementsOptions,"confirm-params":_vm.confirmParams}}),_vm._v(" "+_vm._s(_vm.elementsOptions.clientSecret)+" "),_c('button',{on:{"click":_vm.pay}},[_vm._v("Pay")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }